/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';

export const Divider = () => <hr className={"p-divider p-margin-none p-padding-none"} />;
